/**
 * Temperature gradient coloring based on deviation from setpoint.
 * blue (cold) ↔ green (at setpoint) ↔ red (warm)
 */

const GREEN = [74, 222, 128] // #4ADE80
const RED = [241, 132, 132] // #F18484
const BLUE = [96, 165, 250] // #60A5FA

/** Full deviation scale in °C — beyond this, color is fully saturated */
const MAX_DEVIATION = 10

function lerp(a: number[], b: number[], t: number): string {
  const r = Math.round(a[0] + (b[0] - a[0]) * t)
  const g = Math.round(a[1] + (b[1] - a[1]) * t)
  const bl = Math.round(a[2] + (b[2] - a[2]) * t)
  return `rgb(${r},${g},${bl})`
}

/** Return a color for `temp` relative to `setpoint`: green at setpoint, red when warm, blue when cold */
export function temperatureColor(temp: number, setpoint: number): string {
  const deviation = temp - setpoint
  const t = Math.min(Math.abs(deviation) / MAX_DEVIATION, 1)
  if (deviation > 0) return lerp(GREEN, RED, t)
  if (deviation < 0) return lerp(GREEN, BLUE, t)
  return `rgb(${GREEN[0]},${GREEN[1]},${GREEN[2]})`
}
